import React, { useState } from "react";
import { Modal, Button } from "react-bootstrap";

/**
 * Shows a list of available caller numbers so the user can pick one before
 * an outbound call from the database/lead list.
 *
 * Props
 *   destination      — the number being dialled (display only)
 *   assignedNumbers  — array of { extensionNumber, PBX_TELEPHONE } objects
 *   defaultCaller    — PBX_TELEPHONE pre-selected by default
 *   onConfirm(tel)   — called with the chosen PBX_TELEPHONE
 *   onCancel()       — called when the user dismisses the modal
 */
const CallerSelectionModal = ({
  destination,
  assignedNumbers = [],
  defaultCaller,
  onConfirm,
  onCancel,
}) => {
  const initial = defaultCaller || assignedNumbers[0]?.PBX_TELEPHONE || null;
  const [selected, setSelected] = useState(initial);

  return (
    <Modal show onHide={onCancel} centered size="sm">
      <Modal.Header closeButton>
        <Modal.Title style={{ fontSize: 15 }}>Select Caller Number</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div className="text-muted small mb-3">
          Calling: <strong>{destination}</strong>
        </div>
        {assignedNumbers.map((e) => (
          <div
            key={e.extensionNumber}
            onClick={() => setSelected(e.PBX_TELEPHONE)}
            style={{
              display: "flex", alignItems: "center", gap: 10,
              padding: "8px 12px", marginBottom: 6, borderRadius: 6, cursor: "pointer",
              border: `1.5px solid ${selected === e.PBX_TELEPHONE ? "#3b82f6" : "#e5e7eb"}`,
              background: selected === e.PBX_TELEPHONE ? "#eff6ff" : "#f9fafb",
            }}
          >
            <input
              type="radio"
              readOnly
              checked={selected === e.PBX_TELEPHONE}
              style={{ accentColor: "#3b82f6" }}
            />
            <div>
              <div style={{ fontSize: 13, fontWeight: 600 }}>{e.PBX_TELEPHONE}</div>
              <div style={{ fontSize: 11, color: "#6b7280" }}>Ext {e.extensionNumber}</div>
            </div>
            {defaultCaller === e.PBX_TELEPHONE && (
              <span
                style={{
                  marginLeft: "auto", fontSize: 10, background: "#dbeafe",
                  color: "#1d4ed8", padding: "2px 6px", borderRadius: 10,
                }}
              >
                Default
              </span>
            )}
          </div>
        ))}
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" size="sm" onClick={onCancel}>
          Cancel
        </Button>
        <Button
          variant="primary"
          size="sm"
          disabled={!selected}
          onClick={() => onConfirm(selected)}
        >
          Call
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default CallerSelectionModal;
